import React from "react";

const NessunaSezione = () => {
    return (
        <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "28px",
            borderRadius: "12px",
            background: "linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%)",
            boxShadow: "0 6px 18px rgba(20, 24, 40, 0.06)",
            color: "#0f172a",
            margin: "12px 0"
        }}>
            <div style={{maxWidth: 760, textAlign: "center"}}>
                <svg width="56" height="56" viewBox="0 0 24 24" fill="none" style={{marginBottom: 8}}>
                    <rect x="1" y="1" width="22" height="22" rx="6" fill="#eef2ff"/>
                    <path d="M12 7v6" stroke="#4c51bf" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 16h.01" stroke="#4c51bf" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <h3 style={{margin: "6px 0 8px", fontSize: "1.125rem", fontWeight: 600}}>Nessuna Sezione Configurata</h3>
                <p style={{margin: 0, color: "#475569"}}>
                    Per questa Camera non sono state configurate le sezioni A, B o C. Contatta l'amministratore per abilitare i contenuti.
                </p>
            </div>
        </div>
    );
};

export default NessunaSezione;
